







































import { defineComponent, computed, reactive } from '@vue/composition-api';
import { scaleToViewBox } from './utils/viewport-utils';

export default defineComponent({
    name: 'WokChartBarMini',

    props: {
        width: {
            type: [String, Number],
            default: 100
        },
        height: {
            type: [String, Number],
            default: 18
        },
        barColor: {
            type: String,
            default: ''
        },
        axisColor: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: ''
        },
        values: {
            type: Array,
            default: () => []
        },
        vMin: {
            type: [String, Number],
            default: undefined
        },
        vMax: {
            type: [String, Number],
            default: undefined
        },
        showAxis: {
            type: [String, Boolean],
            default: false
        },
        showGaps: {
            type: [String, Boolean],
            default: true
        }
    },

    setup(props, context) {
        const state = reactive({
            width: typeof props.width == 'string' ? parseInt(props.width) : props.width,
            height: typeof props.height == 'string' ? parseInt(props.height) : props.height,
            vMin: typeof props.vMin == 'string' ? parseInt(props.vMin) : props.vMin,
            vMax: typeof props.vMax == 'string' ? parseInt(props.vMax) : props.vMax,
            showGaps: props.showGaps.toString() == 'true',
            showAxis: props.showAxis.toString() == 'true'
        });

        const viewBox = computed(() => {
            return `0 0 ${state.width} ${state.height}`;
        });

        const barThickness = computed(() => {
            let gaps = 0;

            if (state.showGaps) {
                gaps = props.values.length * 2;
            }

            return (state.width - gaps) / props.values.length;
        });

        const points = computed(() => {
            let points = (props.values as number[]).map((y: number, i: number) => [i, y]);
            return scaleToViewBox(points, state.width, state.height, 0.5, state.vMin, state.vMax);
        });

        const filteredPoints = computed(() => {
            return points.value.filter((x: (number|null)[]) => x[1] != null && x[1] != state.height);
        });

        return {
            state,
            viewBox,
            barThickness,
            filteredPoints
        }
    }
})
